<template>
  <v-sheet
    v-if="loading || hasData"
    color="grey lighten-4"
    rounded
    class="mt-4 px-4 d-flex align-center"
    min-height="40"
  >
    <v-progress-circular
      v-if="loading"
      indeterminate
      size="18"
      width="2"
      color="grey darken-1"
      class="mx-auto"
    />

    <div v-else-if="error" class="text-caption red--text">
      Legende konnte nicht geladen werden.
    </div>

    <div 
      v-else
      :class="['d-flex w-full', orientation === 'vertical' ? 'flex-column py-2' : 'flex-row flex-wrap align-center']"
    >
      <div 
        v-for="(label, color) in filteredLegend" 
        :key="color"
        :class="['d-flex align-center', orientation === 'vertical' ? 'mb-1' : 'mr-5']"
      >
        <div 
          :style="{ backgroundColor: color, width: '12px', height: '12px', borderRadius: '2px' }"
          class="mr-2 elevation-1"
        ></div>
        <span class="text-caption grey--text text--darken-3" v-html="label"></span>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LegendComponent',
  props: {
    service: { type: String, required: true },
    usedColors: { type: Array, default: () => [] },
    orientation: { 
      type: String, 
      default: 'horizontal',
      validator: (v) => ['horizontal', 'vertical'].includes(v)
    }
  },
  data: () => ({
    legendData: {},
    loading: false,
    error: false
  }),
  computed: {
    hasData() {
      return Object.keys(this.filteredLegend).length > 0;
    },
    filteredLegend() {
      if (!this.legendData) return {};
      if (!this.usedColors || this.usedColors.length === 0) {
        return this.legendData;
      }
      return Object.keys(this.legendData)
        .filter(color => this.usedColors.includes(color))
        .reduce((obj, key) => {
          obj[key] = this.legendData[key];
          return obj;
        }, {});
    }
  },
  watch: {
    service: {
      immediate: true,
      handler: 'fetchLegend'
    }
  },
  methods: {
    async fetchLegend() {
      if (!this.service) return;
      this.loading = true;
      this.error = false;
      try {
        const response = await axios({
          method: 'get',
          url: this.service,
          params: { opcode: 'JC', format: 'J' }
        });
        this.legendData = response.data;
      } catch (err) {
        console.error("Legend Fetch Error:", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.text-caption {
  line-height: 1;
  white-space: nowrap;
}
.w-full {
  width: 100%;
}
</style>